import {
  ACTIONS,
  LANG,
  MODAL_CONTENT,
  DOCUMENTS_TAGS,
  DOCUMENTS_BASE_URL_BY_ENTITY,
  QUERY_STATUS,
} from "constants/constants";
import DropdownLinkItem from "core/dropdown/DropdownLinkItem";
import { FormattedMessage } from "react-intl";
import { canUserPerformAction } from "access-roles/general-functions";
import { ENTITY } from "constants/info-header";
import {
  enableBackupModal,
  enableMissionFee,
  enableTwisterButton,
} from "access-roles/mission/functions";
import { ROLE_DELETE_MISSION } from "access-roles/roles";

export const getModalTitle = (val) => {
  const modalTitles = {
    [MODAL_CONTENT.MANAGE_MANAGERS]: {
      id: "manage_manager",
      defaultMessage: "Gérer le manager",
      icon: "user",
    },
    [MODAL_CONTENT.MANAGE_HISTORY_MANAGERS]: {
      id: "manage_history_manager",
      defaultMessage: "Gérer l'historique manager",
      icon: "user",
    },
    [MODAL_CONTENT.MANAGE_POSITION_COEF]: {
      id: "manage_position_coef",
      defaultMessage: "Gérer la position/coefficient",
      icon: "user",
    },
    [MODAL_CONTENT.MANAGE_SALARY]: {
      id: "manage_salary",
      defaultMessage: "Gérer le salaire",
      icon: "salary",
    },
    [MODAL_CONTENT.MANAGE_EXTERNAL_TRAINING]: {
      id: "manage_external_traing",
      defaultMessage: "Gérer les formations externes",
      icon: "book",
    },
    [MODAL_CONTENT.MANAGE_BILLING_CLIENT_HISTORY]: {
      id: "manage_billing_client_history",
      defaultMessage: "Gérer l'historique sociétaire",
      icon: "salary",
    },
    [MODAL_CONTENT.MANAGE_WORK_CONTRACT]: {
      id: "manage_employment_contract",
      defaultMessage: "Gérer le contrat de travail",
      icon: "clients",
    },
    [MODAL_CONTENT.MANAGE_LONG_LEAVE]: {
      id: "manage_long_vacation",
      defaultMessage: "Gérer les congés longs",
      icon: "vacation",
    },
    [MODAL_CONTENT.MANAGE_JOB_HISTORY]: {
      id: "manage_job_history",
      defaultMessage: "Gérer l'historique métier",
      icon: "clients",
    },
    [MODAL_CONTENT.MANAGE_COMPANY_HISTORY]: {
      id: "manage_company_history",
      defaultMessage: "Gérer l'historique sociétaire",
      icon: "book",
    },
    [MODAL_CONTENT.MANAGE_DAILY_FEE]: {
      id: "manage_daily_fee",
      defaultMessage: "Gérer l'historique des honoraires journaliers",
      icon: "salary",
    },
  };

  return modalTitles[val];
};

const fetchDocumentsByTag = ({
  tag,
  availableDocuments,
  lang,
  getDocument,
  entityId,
  idType,
  userScope,
  BASE_URL,
  getDocumentStatus,
}) => {
  const documentsFetched = availableDocuments?.filter((e) => e.tag === tag);

  const onClickHandler = ({ document, docType }) => {
    if (getDocumentStatus === QUERY_STATUS.LOADING) return;
    getDocument({
      documentTag: tag,
      queryParams: {
        [idType]: entityId,
        "template-id": document?.template_id,
        "scope": userScope,
        "doc-type": docType,
      },
      BASE_URL,
    });
  };

  return documentsFetched?.flatMap((e) => {
    const baseProps = {
      enable: true,
      onClick: () => onClickHandler({ document: e, docType: "docx" }),
    };

    if (e.tag === "TAG_MISSION_ORDER" || e.tag === "TAG_SERVICE_CONTRACT") {
      return [
        {
          ...baseProps,
          label: `${lang === LANG.FR ? e.label_fr : e.label_en} - docx`,
        },
        {
          ...baseProps,
          label: `${lang === LANG.FR ? e.label_fr : e.label_en} - pdf`,
          onClick: () => onClickHandler({ document: e, docType: "pdf" }),
        },
      ];
    }

    return [
      {
        label: lang === LANG.FR ? e.label_fr : e.label_en,
        ...baseProps,
      },
    ];
  });
};

export const staffDropdownList = ({
  onClickDropdown,
  userBySlug,
  userRoleList,
  entity,
  canMascarade,
  setIsOpenDeleteModal,
  enableMascarade,
  setIsMascarade,
  staffAccessRights,
  modalAccessForDatatrack,
  availableDocuments,
  getDocument,
  lang,
  userScope,
  getDocumentStatus,
}) => {
  const dropdownItems = [
    ...fetchDocumentsByTag({
      tag: DOCUMENTS_TAGS.TAG_DAV_EMPL_CERT,
      availableDocuments,
      lang,
      getDocument,
      entityId: userBySlug?.id,
      idType: "staff-id",
      userScope,
      BASE_URL: DOCUMENTS_BASE_URL_BY_ENTITY.STAFF,
      getDocumentStatus,
    }),
    ...fetchDocumentsByTag({
      tag: DOCUMENTS_TAGS.TAG_DAV_WLC_LETTER,
      availableDocuments,
      lang,
      getDocument,
      entityId: userBySlug?.id,
      idType: "staff-id",
      userScope,
      BASE_URL: DOCUMENTS_BASE_URL_BY_ENTITY.STAFF,
      getDocumentStatus,
    }),
    ...fetchDocumentsByTag({
      tag: DOCUMENTS_TAGS.TAG_DAV_INS_CERT,
      availableDocuments,
      lang,
      getDocument,
      entityId: userBySlug?.id,
      idType: "staff-id",
      userScope,
      BASE_URL: DOCUMENTS_BASE_URL_BY_ENTITY.STAFF,
      getDocumentStatus,
    }),
    ...fetchDocumentsByTag({
      tag: DOCUMENTS_TAGS.TAG_LIAISON_MAIL,
      availableDocuments,
      lang,
      getDocument,
      entityId: userBySlug?.id,
      idType: "staff-id",
      userScope,
      BASE_URL: DOCUMENTS_BASE_URL_BY_ENTITY.STAFF,
      getDocumentStatus,
    }),
    {
      id: "manage_manager",
      defaultMessage: "Gérer le manager",
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_MANAGERS),
      enable: modalAccessForDatatrack?.manager?.get,
    },
    {
      id: "manage_employment_contract",
      defaultMessage: "Gérer le contrat de travail",
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_WORK_CONTRACT),
      enable: modalAccessForDatatrack?.contract?.get,
    },
    {
      id: "manage_position_coefficient",
      defaultMessage: "Gérer la position/coefficient",
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_POSITION_COEF),
      enable: modalAccessForDatatrack?.coef?.get,
    },
    {
      id: "manage_long_vacation",
      defaultMessage: "Gérer les congés longs",
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_LONG_LEAVE),
      enable: modalAccessForDatatrack?.long_leave?.get,
    },
    {
      id: "resend_confirmation_email",
      defaultMessage: "Renvoyer le mail de confirmation",
      enable: false,
    },
    {
      id: "login_as",
      defaultMessage: "Se connecter en tant que",
      enable: enableMascarade({ roles: userRoleList, entity, canMascarade }),
      onClick: () => setIsMascarade(true),
    },
    {
      id: "delete",
      defaultMessage: "Supprimer",
      enable: canUserPerformAction({
        userRoles: staffAccessRights,
        requiredRoles: ACTIONS.DELETE,
      }),
      onClick: () => setIsOpenDeleteModal(true),
    },
  ];

  return (
    <>
      {dropdownItems.map((item, index) => {
        return (
          (item.enable !== false || item.enable === undefined) && (
            <>
              <DropdownLinkItem
                key={item.id}
                id={item.id}
                onClick={item.onClick}
              >
                {item?.label || (
                  <FormattedMessage
                    id={item.id}
                    defaultMessage={item.defaultMessage}
                  />
                )}
              </DropdownLinkItem>
              {index === 6 && (
                <div
                  className="dropdown-separator"
                  key={`dropdown-separator-${item.id}`}
                />
              )}
            </>
          )
        );
      })}
    </>
  );
};

export const consultantDropdownList = ({
  onClickDropdown,
  enableValidateConsultantEmail,
  userRoleList,
  userBySlug,
  setIsOpenDeleteModal,
  consultantAccessRights,
  modalAccessForDatatrack,
  availableDocuments,
  lang,
  getDocument,
  userScope,
  getDocumentStatus,
}) => {
  const dropdownItems = [
    ...fetchDocumentsByTag({
      tag: DOCUMENTS_TAGS.TAG_DAV_EMPL_CERT,
      availableDocuments,
      lang,
      getDocument,
      entityId: userBySlug?.id,
      idType: "consultant-id",
      userScope,
      BASE_URL: DOCUMENTS_BASE_URL_BY_ENTITY.CONSULTANT,
      getDocumentStatus,
    }),
    ...fetchDocumentsByTag({
      tag: DOCUMENTS_TAGS.TAG_DAV_INS_CERT,
      availableDocuments,
      lang,
      getDocument,
      entityId: userBySlug?.id,
      idType: "consultant-id",
      userScope,
      BASE_URL: DOCUMENTS_BASE_URL_BY_ENTITY.CONSULTANT,
      getDocumentStatus,
    }),
    ...fetchDocumentsByTag({
      tag: DOCUMENTS_TAGS.TAG_DAV_WLC_LETTER,
      availableDocuments,
      lang,
      getDocument,
      entityId: userBySlug?.id,
      idType: "consultant-id",
      userScope,
      BASE_URL: DOCUMENTS_BASE_URL_BY_ENTITY.CONSULTANT,
      getDocumentStatus,
    }),
    ...fetchDocumentsByTag({
      tag: DOCUMENTS_TAGS.TAG_DAV_TEST_PERIOD,
      availableDocuments,
      lang,
      getDocument,
      entityId: userBySlug?.id,
      idType: "consultant-id",
      userScope,
      BASE_URL: DOCUMENTS_BASE_URL_BY_ENTITY.CONSULTANT,
      getDocumentStatus,
    }),
    ...fetchDocumentsByTag({
      tag: DOCUMENTS_TAGS.TAG_DAV_NON_COMP,
      availableDocuments,
      lang,
      getDocument,
      entityId: userBySlug?.id,
      idType: "consultant-id",
      userScope,
      BASE_URL: DOCUMENTS_BASE_URL_BY_ENTITY.CONSULTANT,
      getDocumentStatus,
    }),
    ...fetchDocumentsByTag({
      tag: DOCUMENTS_TAGS.TAG_LIAISON_MAIL,
      availableDocuments,
      lang,
      getDocument,
      entityId: userBySlug?.id,
      idType: "consultant-id",
      userScope,
      BASE_URL: DOCUMENTS_BASE_URL_BY_ENTITY.CONSULTANT,
      getDocumentStatus,
    }),
    {
      id: "manage_manager",
      defaultMessage: "Gérer le manager",
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_MANAGERS),
      enable: modalAccessForDatatrack?.manager?.get,
    },
    {
      id: "manage_salary",
      defaultMessage: "Gérer le salaire",
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_SALARY),
      enable: modalAccessForDatatrack?.salary?.get,
    },
    {
      id: "manage_employment_contract",
      defaultMessage: "Gérer le contrat de travail",
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_WORK_CONTRACT),
      enable: modalAccessForDatatrack?.contract?.get,
    },
    {
      id: "manage_position_coefficient",
      defaultMessage: "Gérer la position/coefficient",
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_POSITION_COEF),
      enable: modalAccessForDatatrack?.coef?.get,
    },
    {
      id: "manage_long_vacation",
      defaultMessage: "Gérer les congés longs",
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_LONG_LEAVE),
      enable: modalAccessForDatatrack?.long_leave?.get,
    },
    {
      id: "manage_job_history",
      defaultMessage: "Gérer l'historique métier",
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_JOB_HISTORY),
      enable: modalAccessForDatatrack?.domain?.get,
    },
  ];

  const canValidateEmail = enableValidateConsultantEmail({
    roles: userRoleList,
    emailValidated: userBySlug?.email_validated,
  });

  const canDelete = canUserPerformAction({
    userRoles: consultantAccessRights,
    requiredRoles: ACTIONS.DELETE,
  });
  return (
    <>
      {dropdownItems.map(
        (item) =>
          item.enable !== false && (
            <DropdownLinkItem key={item.id} id={item.id} onClick={item.onClick}>
              {item?.label || (
                <FormattedMessage
                  id={item.id}
                  defaultMessage={item.defaultMessage}
                />
              )}
            </DropdownLinkItem>
          )
      )}
      {canValidateEmail && canDelete && <div className="dropdown-separator" />}
      {canValidateEmail && (
        <DropdownLinkItem id="resend_confirmation_email">
          <FormattedMessage
            id="resend_confirmation_email"
            defaultMessage="Renvoyer le mail de confirmation"
          />
        </DropdownLinkItem>
      )}
      {canDelete && (
        <DropdownLinkItem
          id="delete"
          onClick={() => setIsOpenDeleteModal(true)}
        >
          <FormattedMessage id="delete" defaultMessage="Supprimer" />
        </DropdownLinkItem>
      )}
    </>
  );
};

export const subcontratorDropdownList = ({
  entity,
  onClickDropdown,
  subcontractorAccessRights,
  setIsOpenDeleteModal,
  modalAccessForDatatrack,
}) => {
  const dropdownItems = [
    {
      id: "manage_manager",
      defaultMessage: "Gérer le manager",
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_MANAGERS),
      enable:
        entity === ENTITY.SUBCONTRACTOR &&
        modalAccessForDatatrack?.manager?.get,
    },
    {
      id: "manage_company_history",
      defaultMessage: "Gérer l'historique sociétaire",
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_COMPANY_HISTORY),
      enable: modalAccessForDatatrack?.subcontractor_company_history?.get,
    },
    {
      id: "delete",
      defaultMessage: "Supprimer",
      onClick: () => setIsOpenDeleteModal(true),
      enable: canUserPerformAction({
        userRoles: subcontractorAccessRights,
        requiredRoles: ACTIONS.DELETE,
      }),
    },
  ];

  return (
    <>
      {dropdownItems.map(
        (item, index) =>
          item.enable !== false && (
            <DropdownLinkItem key={item.id} id={item.id} onClick={item.onClick}>
              <FormattedMessage
                id={item.id}
                defaultMessage={item.defaultMessage}
              />
            </DropdownLinkItem>
          )
      )}
    </>
  );
};

export const clientDropdownList = ({
  onDeleteClick,
  clientAccessRights,
  onClickDropdown,
  modalAccessForDatatrack,
}) => {
  const dropdownItems = [
    {
      id: "manage_company_history",
      defaultMessage: "Gérer l'historique sociétaire",
      onClick: () =>
        onClickDropdown(MODAL_CONTENT.MANAGE_BILLING_CLIENT_HISTORY),
      enable: modalAccessForDatatrack?.subcontractor_company_history?.get,
    },
    {
      id: "delete",
      defaultMessage: "Supprimer",
      onClick: () => onDeleteClick(),
      enable: canUserPerformAction({
        userRoles: clientAccessRights,
        requiredRoles: ACTIONS.DELETE,
      }),
    },
  ];

  return (
    <>
      {dropdownItems.map(
        (item) =>
          item.enable !== false && (
            <DropdownLinkItem key={item.id} id={item.id} onClick={item.onClick}>
              <FormattedMessage
                id={item.id}
                defaultMessage={item.defaultMessage}
              />
            </DropdownLinkItem>
          )
      )}
    </>
  );
};

export const subCompanyDropdownList = ({
  subcontractingCompanyAccessRights,
  setIsOpenDeleteModal,
  getSubcontractorsListExport,
}) => {
  const dropdownItems = [
    {
      id: "export_list_subcontractors",
      defaultMessage: "Exporter la liste des sous-traitants",
      onClick: getSubcontractorsListExport,
      enable: true,
    },
    {
      id: "delete",
      defaultMessage: "Supprimer",
      onClick: () => setIsOpenDeleteModal(true),
      enable: canUserPerformAction({
        userRoles: subcontractingCompanyAccessRights,
        requiredRoles: ACTIONS.DELETE,
      }),
    },
  ];

  return (
    <>
      {dropdownItems.map(
        (item) =>
          item.enable !== false && (
            <DropdownLinkItem key={item.id} id={item.id} onClick={item.onClick}>
              <FormattedMessage
                id={item.id}
                defaultMessage={item.defaultMessage}
              />
            </DropdownLinkItem>
          )
      )}
    </>
  );
};

export const billingClientDropDownList = ({
  setIsOpenDeleteModal,
  billingClientAccessRights,
}) => {
  const dropdownItems = [
    {
      id: "delete",
      defaultMessage: "Supprimer",
      onClick: () => setIsOpenDeleteModal(true),
      enable: canUserPerformAction({
        userRoles: billingClientAccessRights,
        requiredRoles: ACTIONS.DELETE,
      }),
    },
  ];

  return (
    <>
      {dropdownItems.map(
        (item) =>
          item.enable !== false && (
            <DropdownLinkItem key={item.id} id={item.id} onClick={item.onClick}>
              <FormattedMessage
                id={item.id}
                defaultMessage={item.defaultMessage}
              />
            </DropdownLinkItem>
          )
      )}
    </>
  );
};

export const missionDropDownList = ({
  userRoleList,
  missionById,
  onClickDropdown,
  setIsOpenBackupModal,
  setIsOpenDeleteModal,
  missionIsBackupable,
  userScope,
  getMissionQuote,
  modalAccessForMissions,
  missionAccessRights,
  availableDocuments,
  getDocument,
  lang,
  handleDownloadMissionPPT,
  getDocumentStatus,
  creationFileStatus,
  missionQuoteStatus,
}) => {
  const dropdownItems = [
    {
      id: "backup",
      defaultMessage: "Backup",
      enable: enableBackupModal({
        roles: userRoleList,
        missionIsBackupable,
      }),
      onClick: () => setIsOpenBackupModal(true),
    },
    {
      id: "backup_twister",
      defaultMessage: "Modifier le backup (contacter Twister)",
      enable: enableTwisterButton({
        roles: userRoleList,
        missionIsBackupable,
      }),
      to: `/${userScope}/restricted-access`,
      isContactSupportOption: true,
    },
    {
      id: "manager_history",
      defaultMessage: "Historisation manager",
      enable: modalAccessForMissions?.manager?.get,
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_HISTORY_MANAGERS),
    },
    {
      id: "change_daily_fees",
      defaultMessage: "Modifier les honoraires journaliers",
      enable: modalAccessForMissions?.fee?.get,
      onClick: () => onClickDropdown(MODAL_CONTENT.MANAGE_DAILY_FEE),
    },
    {
      id: "delete",
      defaultMessage: "Supprimer",
      enable:
        canUserPerformAction({
          userRoles: userRoleList,
          requiredRoles: ROLE_DELETE_MISSION,
        }) &&
        canUserPerformAction({
          userRoles: missionAccessRights,
          requiredRoles: ACTIONS.DELETE,
        }),
      onClick: () => setIsOpenDeleteModal(true),
    },
    ...fetchDocumentsByTag({
      tag: DOCUMENTS_TAGS.TAG_SERVICE_CONTRACT,
      availableDocuments,
      lang,
      getDocument,
      entityId: missionById?.id,
      idType: "mission-id",
      userScope,
      BASE_URL: DOCUMENTS_BASE_URL_BY_ENTITY.MISSION,
      getDocumentStatus,
    }),
    ...fetchDocumentsByTag({
      tag: DOCUMENTS_TAGS.TAG_MISSION_ORDER,
      availableDocuments,
      lang,
      getDocument,
      entityId: missionById?.id,
      idType: "mission-id",
      userScope,
      BASE_URL: DOCUMENTS_BASE_URL_BY_ENTITY.MISSION,
      getDocumentStatus,
    }),
    {
      id: "mission_quote",
      defaultMessage: "Devis mission",
      enable: enableMissionFee({
        roles: userRoleList,
      }),
      onClick: () => {
        if (missionQuoteStatus === QUERY_STATUS.LOADING) return;
        getMissionQuote({
          missionId: missionById.id,
          slug: missionById?.slug,
        });
      },
    },
    {
      id: "export_sheet",
      defaultMessage: "Exporter Ref",
      enable: missionById?.id && missionById?.slug,
      onClick: () => {
        if (creationFileStatus === QUERY_STATUS.LOADING) return;
        handleDownloadMissionPPT({
          id: missionById?.id,
          slug: missionById?.slug,
        });
      },
    },
  ];

  return (
    <>
      {dropdownItems.map(
        (item) =>
          item.enable && (
            <DropdownLinkItem
              key={item.id}
              id={item.id}
              onClick={item.onClick}
              to={item.to}
              isContactSupportOption={item.isContactSupportOption}
            >
              {item?.label || (
                <FormattedMessage
                  id={item.id}
                  defaultMessage={item.defaultMessage}
                />
              )}
            </DropdownLinkItem>
          )
      )}
    </>
  );
};

export const getModalMessageId = (entity) => {
  const entityMessages = {
    [ENTITY.STAFF]: "modal_delete_staff_msg",
    [ENTITY.CONSULTANT]: "modal_delete_consultant_msg",
    [ENTITY.SUBCONTRACTOR]: "modal_delete_subcontractor_msg",
    [ENTITY.SUBCONTRACTING_COMPANY]: "modal_delete_subcompany_msg",
    [ENTITY.CLIENT]: "modal_delete_client_msg",
    [ENTITY.BILLING_CLIENT]: "modal_delete_billing_msg",
    [ENTITY.MISSION]: "modal_delete_mission_msg",
  };

  return entityMessages[entity];
};

export const createHeader = (
  key,
  defaultMessage,
  icon,
  minWidth,
  paddingLeft = ""
) => ({
  label: {
    key,
    value: <FormattedMessage id={key} defaultMessage={defaultMessage} />,
  },
  icon,
  width: "fit-content",
  minWidth,
  paddingLeft: paddingLeft,
});

export const headerGenerator = (headerParams) => [
  { label: { key: "id", value: "id" } },
  ...headerParams.map((params) =>
    createHeader(
      params.key,
      params.defaultMessage,
      params.icon,
      params.minWidth,
      params.paddingLeft
    )
  ),
];
